<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-11-05 15:38:33
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-09 18:12:53
-->
<template>
  <div style="width:30px;height: 30px">
    <el-popover placement="top" v-model="visible" trigger="manual" ref="popoverRef" v-outside='()=>{visible=false}'>
      <div class="flex flex-bet" style="margin-bottom: 10px">
        <div>
          <el-button v-if="messages&&messages.length>0" @click.stop="clearMessageList">清除当前对话</el-button>
        </div>
        <div title="关闭">
          <i class="el-icon-circle-close cur" @click="closeThePopover" style="font-size: 26px"></i>
        </div>
      </div>
      <div class="chat-box-message">
        <div class="ai-chat-box" ref="aiboxRef">
          <div v-for="(item, index) in messages" :key="index" class="message" :class="item.selfSend ? 'user-message' : 'ai-message'">
            <div v-if="!item.selfSend">
              <img src="@/assets/image/Chatgpt.png" alt="" style="width: 30px;margin-right: 5px;" :title="item.model">
            </div>
            <div>
              <div class="message-text">
                <span :style="{color:item.isError?'red':''}">{{ item.message }}</span><i class="el-icon-loading" v-if="item.isLoading"></i>
              </div>
              <div v-if="!item.selfSend&&!item.isLoading&&!item.isError" style="margin-top: 5px;">
                <span class="cur text-icon" title="复制文本" @click="copyToClipboard(item.message)">
                  <i class="el-icon-document-copy"></i>
                  <span style="margin-left: 2px;">复制</span>
                </span>
                <span class="cur text-icon marL10" title="插入至用户聊天框" @click="insertMessageToChat(item)">
                  <i class="el-icon-bottom-left"></i>
                  <span style="margin-left: 2px;">插入聊天框</span>
                </span>
                <span class="cur text-icon marL10" title="直接发送给用户" @click="sendMessageToCustomer(item)">
                  <i class="el-icon-position"></i>
                  <span style="margin-left: 2px;">直接发送</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-bet flex-align-center">
          <el-input size="small" v-model="inputMessage" placeholder="请输入您的问题...按回车键发送" @keyup.enter.native="sendMessage" clearable ref='inputRef'></el-input>
          <span :title="inputMessage.trim()!==''?'发送':'请输入您的问题'" @click="sendMessage" class="marL10">
            <i class="el-icon-s-promotion" style="font-size: 26px" :class="getInputClass()"></i>
          </span>
        </div>
      </div>
    </el-popover>
    <img ref="imgBox" src="@/assets/image/ai1.png" title="询问 AI" @click.stop="openThePopover('')" style="width:100%;height: 100%;cursor: pointer">
  </div>
</template>
  
<script>
import { copyText } from '@/utils/func.js'
export default {
  props: {
    chatInfo: {}
  },
  computed: {
    mineKey() {
      return `AIChat-${this.$store.state.userStore.userInfo.id}`
    }
  },
  data() {
    return {
      visible: false,
      inputMessage: '',
      sendMsg: '',
      messages: [],
      isLoading: false
    }
  },
  methods: {
    getInputClass() {
      if (this.inputMessage.trim() !== '') {
        return 'send-btn'
      }
      return this.isLoading ? 'not-allowed' : ''
    },

    //直接发送
    sendMessageToCustomer(item) {
      this.$emit('sendMessageToCustomer', item)
    },

    // 插入到聊天框
    insertMessageToChat(item) {
      this.$emit('insertMessageToChat', item)
    },

    // 复制文本
    copyToClipboard(text) {
      copyText(text)
      this.$message.success('复制成功')
    },

    // 清空历史对话
    clearMessageList() {
      this.messages = []
      this.setLocalStorageList(this.messages)
      this.getUpdatePopper()
    },

    // 发送消息
    sendMessage() {
      if (this.isLoading) {
        return false
      }
      if (this.inputMessage.trim()) {
        this.sendMsg = this.inputMessage
        this.messages.push(
          { message: this.sendMsg, selfSend: true },
          { message: '', selfSend: false, model: '', isLoading: true }
        )
        this.inputMessage = ''
        this.scrollToBottom()
        this.getUpdatePopper()
        this.getAIAutoReply()
      }
    },

    // 问问AI
    getAIAutoReply() {
      const data = { message: this.sendMsg }
      const lastMessage = this.messages[this.messages.length - 1]
      this.isLoading = true
      this.$http.get('/chatAiKeFu', { params: data }).then((res) => {
        this.isLoading = false
        lastMessage.model = res.model
        if (res.choices?.length) {
          lastMessage.message = res.choices[0].message.content
          lastMessage.isLoading = false
        } else {
          const errorMsg = 'AI出错了'
          this.handleErrorMessage(lastMessage, errorMsg)
          this.$message.error(errorMsg)
        }
        this.finalizeMessageUpdate()
      }).catch(err => {
        this.isLoading = false
        const errorMsg = err?.message || 'AI出错了'
        this.handleErrorMessage(lastMessage, errorMsg)
        this.finalizeMessageUpdate()
      })
    },

    handleErrorMessage(lastMessage, message) {
      lastMessage.message = message
      lastMessage.isError = true
      lastMessage.isLoading = false
    },

    finalizeMessageUpdate() {
      this.sendMsg = ''
      this.setLocalStorageList(this.messages)
      this.scrollToBottom()
      this.getUpdatePopper()
    },

    // 储存本地
    setLocalStorageList(messages) {
      let messageList = JSON.parse(localStorage.getItem(this.mineKey)) || {}
      messageList[this.chatInfo.targetId] = messages;
      localStorage.setItem(this.mineKey, JSON.stringify(messageList))
    },

    getUpdatePopper() {
      this.$nextTick(() => {
        this.$refs.popoverRef.updatePopper()
      })
    },

    closeThePopover() {
      this.visible = false
    },

    openThePopover(msgInfo) {
      const eventTarget = this.$refs.imgBox
      this.visible = !this.visible
      if (this.visible) {
        this.$refs.popoverRef.referenceElm = eventTarget
        this.inputMessage = ''
        if (localStorage.getItem(this.mineKey)) {
          this.messages = JSON.parse(localStorage.getItem(this.mineKey))[this.chatInfo.targetId] || []
        } else {
          this.messages = []
        }
        if (msgInfo && msgInfo.content) {
          this.inputMessage = msgInfo.content
          this.sendMessage()
        }
        this.scrollToBottom()
        this.$nextTick(() => {
          this.$refs.inputRef.focus()
        })
        this.getUpdatePopper()
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const chatAiboxRef = this.$refs.aiboxRef
        chatAiboxRef.scrollTop = chatAiboxRef.scrollHeight
      })
    }
  }
}
</script>
  
<style scoped lang="scss">
.chat-box-message {
  min-width: 700px;
  margin-bottom: 10px;
  .ai-chat-box {
    max-height: 500px;
    padding-right: 10px;
    overflow: auto;
  }
}
.message {
  margin-bottom: 10px;
}
.el-icon-circle-close:hover {
  color: #409eff;
}
.user-message {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
  .message-text {
    max-width: 700px;
    margin-left: auto;
    background-color: #e0dfff;
    border-radius: 12px;
    line-height: 24px;
    padding: 6px 14px;
    white-space: pre-wrap;
  }
}
.ai-message {
  display: flex;
  flex-direction: row;
  // align-items: center;
  justify-content: flex-start;
  .message-text {
    max-width: 700px;
    background-color: #f7f7f7;
    border-radius: 12px;
    line-height: 24px;
    padding: 6px 14px;
    white-space: pre-wrap;
  }
}
.send-btn {
  cursor: pointer;
  color: #5850da;
}

.el-popover__reference-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-icon:hover {
  color: #409eff;
}
</style>